import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect } from 'react';
import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { faCircleInfo, faCircle } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useProfileContext } from '../../hooks/useProfileContext';
import { useUserContext } from '../../hooks/useUserContext';
import axios from 'axios';
import { useCompanyEmployeesContext } from '../../hooks/useCompanyEmployeesContext';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
const EmployeeCard = ({ employee, idx }) => {
    const location = useLocation()
    const { profile, dispatch } = useProfileContext()
    const [anchorEl, setAnchorEl] = useState(null);
    const { companyName } = useParams();
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useUserContext();
    const tapEntries = Object.entries(employee.numberOfTapsDate);
    const tapLastkey = tapEntries[tapEntries.length - 1];
    const tapLastvalue = tapLastkey[1];
    const contactEntries = Object.entries(employee.noOfContactDownloads);
    const contactlastkey = contactEntries[contactEntries.length - 1];
    const contactlastvalue = contactlastkey[1];
    const { employees, dispatch: compDispatch } = useCompanyEmployeesContext();
    console.log(employees);

    useEffect(()=>{},[
        employees,compDispatch
    ])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseNavigate = () => {
        dispatch({ type: 'SET_PROFILES', payload: employee })
        navigate("/UserDashboard/" + companyName)
        setAnchorEl(null);
    };

    const handleRemoveProfile = async() =>{
        setIsLoading(true)
        const formData = new FormData();
        formData.append('id', employee._id);
        formData.append('company', employee.company);
        await axios.post( `/users/removeUser`, formData, {
            withCredentials: true,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                'Authorization': `Bearer ${user.token}`
            },
        })
            .then(async (res) => {
                setIsLoading(false)
                setAnchorEl(null);
                compDispatch({type:"SET_EMPLOYEES",payload:res.data})
            })
    } 

    return (
        <div className="cardContainer">
            {
                !isLoading? 
                <div className='card-upper'>
                    <Avatar sx={{ width: 90, height: 90 }} alt="Remy Sharp" src={employee.profiles[employee.activeProfile].image1} />
                    {location.pathname.search('edit') !== - 1 && <Button
                        id="demo-positioned-button"
                        aria-controls={open ? 'demo-positioned-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        className='dots'
                    >
                        <FontAwesomeIcon icon={faEllipsisVertical} style={{ color: "#000000", }} />
                    </Button>}
                    {location.pathname.search('edit') !== - 1 && <Menu
                        id="demo-positioned-menu"
                        aria-labelledby="demo-positioned-button"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <MenuItem onClick={handleCloseNavigate}>Edit</MenuItem>
                        {!(employee.manager.length >1) && <MenuItem onClick={handleRemoveProfile}>Remove Profile</MenuItem>}
                    </Menu>}
                </div>:
                <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            }
            <div className='card-middle'>
                <span className='card-name'>{employee.name}</span>
                {(idx !== 0) && <span className='card-second'> {employee.profiles[employee.activeProfile].job} </span>}
            </div>
            {(employee.manager === "Mimar Red" || employee.manager === "Mimar Blue") ? <div style={{ 'opacity': '0.5', 'fontSize': '14px' }}>
                Here is your corporate profile, any edit in this profile will immediatley change in all profiles.
            </div>
                : <div className='card-lower'>
                    <div className='taps'>
                        <span className='tap'>{contactlastvalue}</span>
                        <span className='card-second'>Contact</span>
                    </div>
                    <div className='taps'>
                        <span className='con'> {tapLastvalue} </span>
                        <span className='card-second'>taps</span>
                    </div>
                </div>
            }
        </div>
    )
}

export default EmployeeCard